import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Configurer from "../../components/Configurer";
import StagesManager from "../../components/StagesManager";
import { checkTranslation, conditionalWidth, imageAddress, pathMaker, translate } from "../../utils/useful";
import Cookies from "universal-cookie";
import PageStatusViewer from "../../components/PageStatusViewer";

import { ConnectionsPages } from "../../variables/AppletPages";
import TLink from "../../components/TLink";
import BoxesView from "../../components/views/BoxesView";
import FormView from "../../components/views/FormView";
import DashboardView from "../../components/views/DashboardView";
import Responsive from "../../components/Responsive";
import CollectionView from "./database/CollectionView";


class ConnectionsApplet extends React.Component {

    state = {
        modules: [],

    }



    componentDidMount() {

        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }

    }


    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                let accessPages = Object.values(ConnectionsPages.pages)
                let accessSections = Object.values(ConnectionsPages.sections)

                this.setState({ modules: accessPages, sections: accessSections }, () => {
                    this.checkDefaultTab()
                    // this.fetchSettings()

                })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)

                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }


    setData = (key, value, reference, cb) => {
        if (reference == 'ConnectionsApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }
    componentDidUpdate(prevProps) {
        // let windowPath = this.props.windowData//.split('/')
        // windowPath = windowPath[windowPath.length - 1]


        if ((this.state.oldData && this.state.oldData != this.props.windowData) || this.props.width != prevProps.width) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
                // console.log("DKLJDJKDLQK")
            })
        }
    }

    setHeader = (key, value) => {

        // console.log("setHeader")

        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }

                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                // this.state.headerConfig = { showToolbar: true, topHeaderComponent: null, backAction: null }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }

                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }

                // console.log('objis', this.props.defaultHeaderConfig)


                // console.log('objis', object)
                this.setState({ headerConfig: object }, () => {
                    // console.log(this.state.headerConfig)
                    this.header?.forceUpdate()
                })


            }
            else {
                // console.log("setHeader")
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this?.header.forceUpdate()
                })
            }
        }
    }



    changePage = (page) => {

        let path
        if (page) {
            path = [page?.key ?? page]
        }
        console.log('changepage', path)
        this.props.changeWindowLink(path)

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    render() {

        // console.log(this.props.applet)

        let variables = {
            appletId: this.props.applet?._id,
            appletHub: typeof this.props.applet?.hub == 'object' ? this.props.applet?.hub._id : this.props.applet?.hub,
            targetId: typeof this.props.applet?.hub == 'object' ? this.props.applet?.hub._id : this.props.applet?.hub,
        }

        return (

            <div className="h-100">

                <PageStatusViewer status={this.state.pageStatus}>

                    <div className=" w-100 h-100  window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>
                        <div className='d-flex w-100 h-100'>

                            {(conditionalWidth(this.props.width, { xs: false, sm: true }) || !this.state.page) && (
                                <Responsive height="100%" width={this.props.width} media={{ xs: "12", sm: '4', md: '3', lg: "3", xl: "3" }}>

                                    <div className='scroll-no-scrollbar h-100 pt-3 pb-4 w-100 d-flex flex-column' >
                                        <div>
                                            <div onClick={() => this.props.goToHub()} className='flexc pb-3 px-3 cursor-pointer' style={{ borderBottom: '1px solid #eee' }}>
                                                <img src={imageAddress(this.props.applet?.hub?.image, 'profile', 'small')} width="40px" style={{ height: 40, objectFit: 'cover', borderRadius: 100 }} />
                                                <div className='mld-2'>
                                                    <h2 className="m-0 text-normal mb-0" >{this.props.applet?.hub?.fullname}</h2>
                                                    <div style={{ maxWidth: 450 }}>
                                                        <p className="mt-0 text-small color-gray-1" >{translate('Connection')}</p>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="mt-0">

                                                <button onClick={() => this.changePage('')} className='flexc w-100 pb-3 pt-3 px-3 cursor-pointer transition-all' style={{ backgroundColor: this.state.page?.key == null ? '#eee' : '' }}>
                                                    <div className="flexc">
                                                        <img className="transition-all" src={'/assets/icons/applets/general/bell.png'} height={22} style={{ filter: this.state.page?.key == null ? '' : 'saturate(0%)' }} />
                                                        <div className='d-flex flex-column mld-3'>
                                                            <p className={'text-semibold text-small text-capitalize ' + (this.state.page?.key == null ? "" : "color-gray-3")}>{translate("Dashboard")}</p>

                                                        </div>
                                                    </div>

                                                </button>

                                                {this.state.sections?.map((section, i) => {
                                                    return (
                                                        <div className="w-100" style={{ borderBottom: '1px solid #e8e8e8' }}>

                                                            {this.state.modules.map((item, index) => {
                                                                if (section.key == item.section)
                                                                    return (
                                                                        <div className='w-100 ' key={index}>
                                                                            <button onClick={() => this.changePage(item)} className='flexc w-100 pb-3 pt-3 px-3 cursor-pointer transition-all' style={{ backgroundColor: this.state.page?.key == item.key ? '#eee' : '' }}>
                                                                                <div className='flexcc'>
                                                                                    <img className="transition-all" src={item.icon} height={22} style={{ filter: this.state.page?.key == item.key ? '' : 'saturate(0%)' }} />
                                                                                </div>
                                                                                <div className='d-flex flex-column mld-3'>
                                                                                    <p className={'text-semibold text-small text-capitalize ' + (this.state.page?.key == item.key ? "" : "color-gray-3")}>{checkTranslation(item.title)}</p>
                                                                                    {/* <p className='text-smallest color-gray-4'>{translate(item.description)}</p> */}

                                                                                </div>
                                                                            </button>
                                                                        </div>
                                                                    )
                                                            })}

                                                        </div>
                                                    )
                                                })}

                                            </div>
                                        </div>
                                    </div>

                                </Responsive>
                            )}

                            {(conditionalWidth(this.props.width, { xs: false, sm: true }) || this.state.page) && (

                                <Responsive width={this.props.width} height="100%" media={{ xs: "12", sm: '8', md: '9', lg: "9", xl: "9" }}>


                                    <div className="w-100 h-100 scroll-no-scrollbar window-content-radius " ref={el => this.pageContainer = el} style={{ backgroundColor: '#fff' }} >

                                        <StagesManager ref={el => this.stageManager = el} fast={true} >
                                            <DashboardView setHeader={this.setHeader} setData={this.setData} applet={this.props.applet} pages={this.state.pages} width={this.props.width} type={'Connections'} stage={0} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} onClick={this.changePage} title={"Manage"} description={"Manage things and applets"} route={this.props.route} variables={variables} />

                                            <CollectionView stageName={'collection'} isMobile={this.props.isMobile} permissions={this.props.permissions} ref={el => this.collectionView = el} setData={this.setData} setHeader={this.setHeader} colors={this.props.colors} width={this.props.width} height={this.props.height} formPages={this.state.page?.formPages} page={this.state.page} baseUrl={[...this.props.baseUrl]} applet={this.props.applet} headers={this.state.headers} automations={this.state.automations} language={this.props.language} userSettings={this.state.userSettings} lastStagePage={this.lastStagePage} changeWindowLink={this.props.changeWindowLink} changeStage={this.changeStage} goToHub={this.props.goToHub} variables={this.props.variables} />

                                            <FormView setHeader={this.setHeader} setData={this.setData} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} stageName={'table'} route={this.props.route} variables={variables} />
                                            <BoxesView setHeader={this.setHeader} setData={this.setData} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} stageName={'boxes'} route={this.props.route} />
                                        </StagesManager>

                                    </div>

                                </Responsive>
                            )}
                        </div>

                    </div>


                </PageStatusViewer>
            </div>
        )
    }








    checkDefaultTab() {

        // console.log("checkDefaultTab")
        let def = ''
        let pageType = null
        let pageInfo = null
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let rootRef = this.props.route.split('/')
        rootRef = rootRef[rootRef.length - 1]
        pathname.forEach((path, index) => {
            if (path == (rootRef)) {
                def = pathname[index + 1]
            }
        });

        // console.log(this.props.route)


        let pageIsValid = false
        // let accessPages = Object.values(SettingsPages.pages)

        Object.values(this.state.modules).forEach(page => {

            let defaultPage = page.defaultPage
            if (conditionalWidth(this.props.width, { xs: true, sm: false })) {
                defaultPage = false
            }
            // console.log(def)
            // console.log(((def==''|| !def) && page.defaultPage))
            if ((page.key.toLowerCase() === def?.toLowerCase()) || ((def == '' || !def) && defaultPage)) {
                pageIsValid = true
                pageType = page.pageType
                // console.log(page)
                pageInfo = page

                if ((def == '' || !def)) {
                    def = page?.key
                    this.changePage(page?.key)
                }
            }

        });
        if (!def) {
            def = ''
        }
        // console.log(def)
        if (def === '') {
            pageType = ''
            pageIsValid = true
            // this.changePage('general')

        }
        if (pageIsValid) {
            // this.state.page = page
            console.log(pageType)
            this.setState({ oldData: this.props.windowData }, () => {
                this.setState({ path: def, pageType }, () => {
                    // console.log(pageType) 


                    setTimeout(() => {
                        this.setState({ page: null }, () => {

                            this.setState({ page: pageInfo, pageType, pageStatus: 200 }, () => {
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                        this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                    })
                                } else {

                                }
                            })
                        })
                    }, 10);
                })

            })
        } else {
            this.setState({ pageStatus: 404 })
        }

    }



}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConnectionsApplet);
